<div class="card solicitudes-table">
  <p-toast></p-toast>
  <p-toolbar styleClass="mb-1 gap-1">
    <ng-template pTemplate="left">
      <p-selectButton
        [options]="viewOptions"
        [(ngModel)]="viewSelected"
        optionLabel="label"
        optionValue="value"
        (onChange)="getDataOfView()"
      ></p-selectButton>
    </ng-template>
    <ng-template pTemplate="right"> </ng-template>
  </p-toolbar>

  <div *ngIf="showApplicationTable">
    <p-table
      #dt
      [value]="applications"
      [rows]="5"
      [paginator]="true"
      [globalFilterFields]="[
        'type',
        'applicant.name',
        'applicant.lastName',
        'applicant.idType',
        'applicant.idNumber',
        'applicant.contactInformation.email',
        'process.processStage',
        'created_at'
      ]"
      responsiveLayout="stack"
      [breakpoint]="'960px'"
      [(selection)]="selectedApplications"
      [rowHover]="true"
      dataKey="ApplicationId"
      currentPageReportTemplate="Registros del {first} al {last} de {totalRecords} registros"
      [showCurrentPageReport]="true"
    >
      <ng-template pTemplate="caption">
        <button
          pButton
          label="Limpiar Filtros"
          class="p-button-outlined"
          icon="pi pi-filter-slash"
          (click)="clear(dt)"
        ></button>

        <span class="p-input-icon-left ml-auto">
          <i class="pi pi-search"></i>
          <input
            pInputText
            type="text"
            (input)="dt.filterGlobal($any($event.target).value, 'contains')"
            placeholder="Búsqueda por palabras"
          />
        </span>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th id="tipoSolicitud" class="table__header-title">
            Tipo Solicitud

            <p-columnFilter
              type="text"
              field="type"
              display="menu"
              [showMatchModes]="false"
              matchMode="contains"
              [hideOnClear]="true"
            ></p-columnFilter>
          </th>
          <th id="tipoSolicitud" class="table__header-title">
            Club

            <p-columnFilter
              type="text"
              field="club"
              display="menu"
              [showMatchModes]="false"
              matchMode="contains"
              [hideOnClear]="true"
            ></p-columnFilter>
          </th>
          <th id="tipoSolicitud" class="table__header-title">
            Modalidad

            <p-columnFilter
              type="text"
              field="modalidad"
              display="menu"
              [showMatchModes]="false"
              matchMode="contains"
              [hideOnClear]="true"
            ></p-columnFilter>
          </th>
          <th id="nombre" class="table__header-title">
            Nombre
            <p-columnFilter
              type="text"
              field="applicant.name"
              display="menu"
              [showMatchModes]="false"
              matchMode="contains"
              [hideOnClear]="true"
            ></p-columnFilter>
          </th>
          <th
            id="apellido"
            pSortableColumn="apellido"
            class="table__header-title"
          >
            Apellido

            <p-columnFilter
              type="text"
              field="applicant.lastName"
              display="menu"
              [showMatchModes]="false"
              matchMode="contains"
              [hideOnClear]="true"
            ></p-columnFilter>
          </th>
          <th
            id="tipoIdentificacion"
            pSortableColumn="tipoIdentificacion"
            class="table__header-title"
          >
            Tipo Identificación
          </th>
          <th
            id="numeroIdentificacion"
            pSortableColumn="numeroIdentificacion"
            class="table__header-title"
          >
            Numero Identificación

            <p-columnFilter
              type="text"
              field="applicant.idNumber"
              display="menu"
              [showMatchModes]="false"
              matchMode="contains"
              [hideOnClear]="true"
            ></p-columnFilter>
          </th>
          <th
            id="status"
            pSortableColumn="process.processStage"
            class="table__header-title"
          >
            Estado<p-sortIcon
              field="process.processStage"
              class="table__header-sortIcon"
            ></p-sortIcon>
          </th>
          <th
            id="fechaSolicitud"
            pSortableColumn="created_at"
            class="table__header-title"
          >
            Fecha Solicitud
            <p-sortIcon
              field="created_at"
              class="table__header-sortIcon"
            ></p-sortIcon>
          </th>
          <th
            id="actions"
            pSortableColumn="actions"
            class="table__header-title"
          >
            Acciones
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-application let-columns="columns">
        <tr>
          <td>
            <span class="p-column-title font-bold">Tipo Solicitud</span>
            {{
              application?.type === "nuevo"
                ? "Nueva Vinculación"
                : application?.type === "transferencia"
                ? "Transferencia"
                : application?.type === "renovacion"
                ? "Renovación de Vinculación"
                : "Error"
            }}
          </td>
          <td>
            <span class="p-column-title font-bold">Club</span
            >{{ application?.club?.name }}
          </td>
          <td>
            <span class="p-column-title font-bold">Modalidad</span
            >{{ application?.modalidad }}
          </td>
          <td>
            <span class="p-column-title font-bold">Nombres</span
            >{{ application?.applicant?.name }}
          </td>
          <td>
            <span class="p-column-title font-bold">Apellidos</span
            >{{ application?.applicant?.lastName }}
          </td>
          <td>
            <span class="p-column-title font-bold">Tipo Id</span
            >{{ application?.applicant?.idType }}
          </td>
          <td>
            <span class="p-column-title font-bold">Id</span
            >{{ application?.applicant?.idNumber }}
          </td>
          <td>
            <span class="p-column-title font-bold">Estado</span>
            {{ getSeverity(application.process.processStage) }}
            <div class="d-flex align-items-center">
              <p-button
                *ngIf="application.process.processStage === 'rejected'"
                (click)="viewRejectedReason(application)"
                icon="pi pi-comments"
                [rounded]="true"
                [text]="true"
                severity="success"
                pTooltip="Ver comentarios de rechazo"
              />
            </div>
          </td>
          <td>
            <span class="p-column-title font-bold">Fecha Solicitud</span
            >{{ getHumanTime(application?.created_at) }}
          </td>
          <td>
            <span class="p-column-title font-bold">Acciones</span>
            <div class="flex align-items-center">
              <p-button
                icon="pi pi-eye"
                [rounded]="true"
                [text]="true"
                [raised]="true"
                severity="primary"
                class="table__button"
                pTooltip="Ver Solicitud"
                tooltipPosition="bottom"
                (click)="initReviewApplication(application)"
              />
              <p-button
                icon="pi pi-pencil"
                [rounded]="true"
                [text]="true"
                [raised]="true"
                severity="warning"
                class="table__button"
                pTooltip="Editar Solicitud"
                tooltipPosition="bottom"
                *ngIf="
                  application.process.processStage ===
                  'accepted_payment_pending' || application.process.processStage ===
                  'payment_abandoned'
                "
                pButton
                pRipple
                icon="pi pi-pencil"
                class="p-button-rounded p-button-warning m-1"
                (click)="initEditApplication(application)"
              />
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="summary">
        <div class="flex align-items-center justify-content-between">
          Total de solicitudes {{ applications ? applications.length : 0 }}.
        </div>
      </ng-template>
    </p-table>
  </div>

  <div *ngIf="showTransfersTable">
    <p-table
      #dt
      [value]="transfers"
      [rows]="5"
      [paginator]="true"
      [globalFilterFields]="[
        'type',
        'member.name',
        'memberastName',
        'member.idType',
        'member.idNumber',
        'process.processStage',
        'created_at'
      ]"
      responsiveLayout="stack"
      [breakpoint]="'960px'"
      [(selection)]="selectedTransfers"
      [rowHover]="true"
      dataKey="id"
      currentPageReportTemplate="Registros del {first} al {last} de {totalRecords} registros"
      [showCurrentPageReport]="true"
    >
      <ng-template pTemplate="caption">
        <button
          pButton
          label="Limpiar Filtros"
          class="p-button-outlined"
          icon="pi pi-filter-slash"
          (click)="clear(dt)"
        ></button>

        <span class="p-input-icon-left ml-auto">
          <i class="pi pi-search"></i>
          <input
            pInputText
            type="text"
            (input)="dt.filterGlobal($any($event.target).value, 'contains')"
            placeholder="Búsqueda por palabras"
          />
        </span>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th id="tipoSolicitud" class="table__header-title">
            Tipo Solicitud

            <p-columnFilter
              type="text"
              field="type"
              display="menu"
              [showMatchModes]="false"
              matchMode="contains"
              [hideOnClear]="true"
            ></p-columnFilter>
          </th>
          <th id="tipoSolicitud" class="table__header-title">
            Club Solicitante

            <p-columnFilter
              type="text"
              field="club"
              display="menu"
              [showMatchModes]="false"
              matchMode="contains"
              [hideOnClear]="true"
            ></p-columnFilter>
          </th>
          <th id="tipoSolicitud" class="table__header-title">
            Modalidad

            <p-columnFilter
              type="text"
              field="modalidad"
              display="menu"
              [showMatchModes]="false"
              matchMode="contains"
              [hideOnClear]="true"
            ></p-columnFilter>
          </th>
          <th id="nombre" class="table__header-title">
            Nombre
            <p-columnFilter
              type="text"
              field="member.name"
              display="menu"
              [showMatchModes]="false"
              matchMode="contains"
              [hideOnClear]="true"
            ></p-columnFilter>
          </th>
          <th
            id="apellido"
            pSortableColumn="apellido"
            class="table__header-title"
          >
            Apellido

            <p-columnFilter
              type="text"
              field="member.lastName"
              display="menu"
              [showMatchModes]="false"
              matchMode="contains"
              [hideOnClear]="true"
            ></p-columnFilter>
          </th>
          <th
            id="tipoIdentificacion"
            pSortableColumn="tipoIdentificacion"
            class="table__header-title"
          >
            Tipo Identificación
          </th>
          <th
            id="numeroIdentificacion"
            pSortableColumn="numeroIdentificacion"
            class="table__header-title"
          >
            Numero Identificación

            <p-columnFilter
              type="text"
              field="member.idNumber"
              display="menu"
              [showMatchModes]="false"
              matchMode="contains"
              [hideOnClear]="true"
            ></p-columnFilter>
          </th>
          <th
            id="status"
            pSortableColumn="process.processStage"
            class="table__header-title"
          >
            Estado<p-sortIcon
              field="process.processStage"
              class="table__header-sortIcon"
            ></p-sortIcon>
          </th>
          <th
            id="fechaSolicitud"
            pSortableColumn="created_at"
            class="table__header-title"
          >
            Fecha Solicitud
            <p-sortIcon
              field="auditData.createdDate"
              class="table__header-sortIcon"
            ></p-sortIcon>
          </th>
          <th
            id="actions"
            pSortableColumn="actions"
            class="table__header-title"
          >
            Acciones
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-transfer let-columns="columns">
        <tr>
          <td>
            <span class="p-column-title font-bold">Tipo Solicitud</span>
            TRANSFERENCIA
          </td>
          <td>
            <span class="p-column-title font-bold">Club Solicitante</span
            >{{ getClubById(transfer.applicantClubId)?.name }}
          </td>
          <td>
            <span class="p-column-title font-bold">Modalidad</span
            >{{ transfer.modalidad }}
          </td>
          <td>
            <span class="p-column-title font-bold">Nombres</span
            >{{ transfer.member.name }}
          </td>
          <td>
            <span class="p-column-title font-bold">Apellidos</span
            >{{ transfer.member.lastName }}
          </td>
          <td>
            <span class="p-column-title font-bold">Tipo Id</span
            >{{ transfer.member.idType }}
          </td>
          <td>
            <span class="p-column-title font-bold">Id</span
            >{{ transfer.member.idNumber }}
          </td>
          <td>
            <span class="p-column-title font-bold">Estado</span>
            {{ getSeverity(transfer.process.processStage) }}
            <div class="d-flex align-items-center">
              <p-button
                *ngIf="transfer.member.processStage === 'rejected'"
                (click)="viewRejectedReason(transfer)"
                icon="pi pi-comments"
                [rounded]="true"
                [text]="true"
                severity="success"
                pTooltip="Ver comentarios de rechazo"
              />
            </div>
          </td>
          <td>
            <span class="p-column-title font-bold">Fecha Solicitud</span
            >{{ getHumanTime(transfer?.auditData.createdDate) }}
          </td>
          <td>
            <span class="p-column-title font-bold">Acciones</span>
            <div class="flex align-items-center">
              <p-button
                icon="pi pi-eye"
                [rounded]="true"
                [text]="true"
                [raised]="true"
                severity="primary"
                class="table__button"
                pTooltip="Ver Solicitud"
                tooltipPosition="bottom"
                (click)="initReviewTransfer(transfer)"
              />
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="summary">
        <div class="flex align-items-center justify-content-between">
          Total de solicitudes {{ applications ? applications.length : 0 }}.
        </div>
      </ng-template>
    </p-table>
  </div>

  <div *ngIf="showRenewalsTable">
    <p-table
      #dt
      [value]="renewals"
      [rows]="5"
      [paginator]="true"
      [globalFilterFields]="[
        'member.name',
        'member.lastName',
        'member.idType',
        'member.idNumber',
        'process.processStage',
        'auditData.createdDate'
      ]"
      responsiveLayout="stack"
      [breakpoint]="'960px'"
      [(selection)]="selectedRenewals"
      [rowHover]="true"
      dataKey="id"
      currentPageReportTemplate="Registros del {first} al {last} de {totalRecords} registros"
      [showCurrentPageReport]="true"
    >
      <ng-template pTemplate="caption">
        <button
          pButton
          label="Limpiar Filtros"
          class="p-button-outlined"
          icon="pi pi-filter-slash"
          (click)="clear(dt)"
        ></button>

        <span class="p-input-icon-left ml-auto">
          <i class="pi pi-search"></i>
          <input
            pInputText
            type="text"
            (input)="dt.filterGlobal($any($event.target).value, 'contains')"
            placeholder="Búsqueda por palabras"
          />
        </span>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th id="tipoSolicitud" class="table__header-title">
            Tipo Solicitud
          </th>
          <th id="nombre" class="table__header-title">
            Nombre
            <p-columnFilter
              type="text"
              field="member.name"
              display="menu"
              [showMatchModes]="false"
              matchMode="contains"
              [hideOnClear]="true"
            ></p-columnFilter>
          </th>
          <th
            id="apellido"
            pSortableColumn="apellido"
            class="table__header-title"
          >
            Apellido

            <p-columnFilter
              type="text"
              field="member.lastName"
              display="menu"
              [showMatchModes]="false"
              matchMode="contains"
              [hideOnClear]="true"
            ></p-columnFilter>
          </th>
          <th
            id="tipoIdentificacion"
            pSortableColumn="tipoIdentificacion"
            class="table__header-title"
          >
            Tipo Identificación
          </th>
          <th
            id="numeroIdentificacion"
            pSortableColumn="numeroIdentificacion"
            class="table__header-title"
          >
            Numero Identificación

            <p-columnFilter
              type="text"
              field="member.idNumber"
              display="menu"
              [showMatchModes]="false"
              matchMode="contains"
              [hideOnClear]="true"
            ></p-columnFilter>
          </th>
          <th
            id="status"
            pSortableColumn="process.processStage"
            class="table__header-title"
          >
            Estado<p-sortIcon
              field="process.processStage"
              class="table__header-sortIcon"
            ></p-sortIcon>
          </th>
          <th
            id="monto"
            class="table__header-title"
          >
            Monto
          </th>
          <th
            id="fechaSolicitud"
            pSortableColumn="auditData.createdDate"
            class="table__header-title"
          >
            Fecha Renovación
            <p-sortIcon
              field="auditData.createdDate"
              class="table__header-sortIcon"
            ></p-sortIcon>
          </th>
          <th
            id="actions"
            pSortableColumn="actions"
            class="table__header-title"
          >
            Acciones
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-renewal let-columns="columns">
        <tr>
          <td>
            <span class="p-column-title font-bold">Tipo Solicitud</span>
            RENOVACIÓN
          </td>
          <td>
            <span class="p-column-title font-bold">Nombres</span
            >{{ renewal.member.name }}
          </td>
          <td>
            <span class="p-column-title font-bold">Apellidos</span
            >{{ renewal.member.lastName }}
          </td>
          <td>
            <span class="p-column-title font-bold">Tipo Id</span
            >{{ renewal.member.idType }}
          </td>
          <td>
            <span class="p-column-title font-bold">Id</span
            >{{ renewal.member.idNumber }}
          </td>
          <td>
            <span class="p-column-title font-bold">Estado</span>
            {{ getRenewalSeverity(renewal.process.processStage) }}
          </td>
          <td>
            <span class="p-column-title font-bold">Monto</span
            >{{ getRenewalAmount(renewal) | currency:'COP':'symbol-narrow':'1.0-0' }}
          </td>
          <td>
            <span class="p-column-title font-bold">Fecha Renovación</span
            >{{ getHumanTime(renewal.auditData.createdDate) }}
          </td>
          <td>
            <span class="p-column-title font-bold">Acciones</span>
            <div class="flex align-items-center">
              <p-button
                icon="pi pi-eye"
                [rounded]="true"
                [text]="true"
                [raised]="true"
                severity="primary"
                class="table__button"
                pTooltip="Ver Renovación"
                tooltipPosition="bottom"
                (click)="initReviewRenewal(renewal)"
              />
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="summary">
        <div class="flex align-items-center justify-content-between">
          Total de renovaciones {{ renewals ? renewals.length : 0 }}.
        </div>
      </ng-template>
    </p-table>
  </div>
</div>
<p-confirmDialog [style]="{ width: '450px' }"></p-confirmDialog>
